/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1AccesscontrolControllersQueryResponse,
  GetApiV1AccesscontrolControllers401,
  GetApiV1AccesscontrolControllers500,
} from "../../types/accessControlControllersController/GetApiV1AccesscontrolControllers.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1AccesscontrolControllers } from "../../clients/accessControlControllersController/getApiV1AccesscontrolControllers.ts";

export const getApiV1AccesscontrolControllersQueryKey = () =>
  [{ url: "/api/v1/accesscontrol/controllers" }] as const;

export type GetApiV1AccesscontrolControllersQueryKey = ReturnType<
  typeof getApiV1AccesscontrolControllersQueryKey
>;

export function getApiV1AccesscontrolControllersQueryOptions(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1AccesscontrolControllersQueryKey();
  return queryOptions<
    GetApiV1AccesscontrolControllersQueryResponse,
    ResponseErrorConfig<
      GetApiV1AccesscontrolControllers401 | GetApiV1AccesscontrolControllers500
    >,
    GetApiV1AccesscontrolControllersQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1AccesscontrolControllers({
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna todos os controllers cadastrados. **(Requer Authorization para autenticação)**
 * @summary Buscar todos os controllers (Requer Authorization para autenticação)
 * {@link /api/v1/accesscontrol/controllers}
 */
export function useGetApiV1AccesscontrolControllers<
  TData = GetApiV1AccesscontrolControllersQueryResponse,
  TQueryData = GetApiV1AccesscontrolControllersQueryResponse,
  TQueryKey extends QueryKey = GetApiV1AccesscontrolControllersQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1AccesscontrolControllersQueryResponse,
        ResponseErrorConfig<
          | GetApiV1AccesscontrolControllers401
          | GetApiV1AccesscontrolControllers500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ?? getApiV1AccesscontrolControllersQueryKey();

  const query = useQuery(
    {
      ...getApiV1AccesscontrolControllersQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      GetApiV1AccesscontrolControllers401 | GetApiV1AccesscontrolControllers500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
